import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, signal, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { UserContextService } from '../../services/user-context.service';
import { MemberStateService } from '../../services/member-state.service';
import { Member } from '../../model/member';

@Component({
  selector: 'myabvv-member-banner',
  standalone: true,
  templateUrl: './member-banner.component.html',
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MemberBannerComponent implements OnInit, OnDestroy {
  private userContext = inject(UserContextService);
  private memberState = inject(MemberStateService);

  readonly isInternalUser = signal(false);
  readonly member = signal<Member | null>(null);
  private sub?: Subscription;

  ngOnInit(): void {
    this.isInternalUser.set(this.userContext.isInternalUser());
    this.sub = this.memberState.getMember().subscribe({
      next: m => this.member.set(m),
      error: err => console.error('[MemberBanner] member load error:', err),
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
